module.exports = __webpack_public_path__ + "img/icon_home_gongsi@2x.8ab86705.png";